import { createI18n } from 'vue-i18n';

import pt from './locales/pt';
import en from './locales/en';
import es from './locales/es';

export function getBrowserLocale(options = {}) {
    const defaultOptions = { countryCodeOnly: false };
    const opt = { ...defaultOptions, ...options };
    const navigatorLocale = navigator.languages !== undefined ? navigator.languages[0] : navigator.language;
    if (!navigatorLocale) {
        return undefined;
    }
    const trimmedLocale = opt.countryCodeOnly ? navigatorLocale.trim().split(/-|_/)[0] : navigatorLocale.trim();
    return trimmedLocale.toLowerCase();
}

const getStartingLocale = () => {
    const browserLocale = getBrowserLocale({ countryCodeOnly: true });
    if (browserLocale === 'pt') return 'pt';
    if (browserLocale === 'es') return 'es';
    return 'en';
};

const startingLocale = getStartingLocale();

// Mantém o atributo lang do documento coerente com o idioma exibido (a11y/SEO)
const documentLang: Record<string, string> = { pt: 'pt-BR', en: 'en', es: 'es' };
document.documentElement.lang = documentLang[startingLocale] ?? 'pt-BR';

export const i18n = createI18n({
    legacy: false,
    globalInjection: true,
    locale: startingLocale,
    fallbackLocale: 'en',
    messages: {
        pt,
        en,
        es,
    },
});
